// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCamOff24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.03033 2.96967C3.73744 2.67678 3.26256 2.67678 2.96967 2.96967C2.67678 3.26256 2.67678 3.73744 2.96967 4.03033L4.0823 5.14296C2.87432 5.53066 2 6.66323 2 8V16C2 17.6569 3.34315 19 5 19H15C15.813 19 16.5505 18.6766 17.0908 18.1514L19.9697 21.0303C20.2626 21.3232 20.7374 21.3232 21.0303 21.0303C21.3232 20.7374 21.3232 20.2626 21.0303 19.9697L17.8853 16.8246C17.96 16.5626 18 16.286 18 16V13.5905L21.3336 16.56C21.8171 16.9907 22.5825 16.6475 22.5825 16V8C22.5825 7.35145 21.815 7.00863 21.332 7.44143L18 10.427V8C18 6.34315 16.6569 5 15 5H6.06066L4.03033 2.96967ZM5.43934 6.5H5C4.17157 6.5 3.5 7.17157 3.5 8V16C3.5 16.8284 4.17157 17.5 5 17.5H15C15.3988 17.5 15.7612 17.3444 16.0299 17.0906L5.43934 6.5ZM16.5 15.4393L7.56066 6.5H15C15.8284 6.5 16.5 7.17157 16.5 8V15.4393ZM18.4805 12.01L21.0825 9.678V14.327L18.4805 12.01Z"
				/>
			</Svg>
		);
	}
);
SvgCamOff24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCamOff24;
